import  { useState } from 'react'
import { Footer } from '../../../components/footer';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import moment from 'moment';
import PropTypes from 'prop-types';
import { copyToClipboard } from '../../../lib/copytoClipboard';
import { useToast } from '../../../hook/usetoast';
import { Check } from 'lucide-react';


const MasterICO = ({ userHistory, page, setPage, rowsPerPage, setRowsPerPage }) => {



    const totalPages = Math.ceil(userHistory?.data?.count / rowsPerPage);

    const handlePageChange = (newPage) => {
        const currentScrollY = window.scrollY;

        if (newPage >= 0 && newPage < totalPages) {
            setPage(newPage);
            window.requestAnimationFrame(() => {
                window.scrollTo(0, currentScrollY);
            });
        }
    };
    const toast = useToast();
    const [uniqueId, setUniqueId] = useState(false)
    const copyuserAddress = async data => {
        setUniqueId(data?._id)
        await copyToClipboard(data?.memberIdby)
        toast.success("Copied Successfully")
        setTimeout(() => {
            setUniqueId(false)
        }, 300);
    }
    return (
        <>
            <div>
                <div>
                    <div className='container'>
                        <div className="row">
                            <div className="col-12">
                                <div className="appcard mb-4 px-0 pb-2 cardbg">
                                    <div className="cardHeader border-bottom-0 d-flex justify-content-between flex-wrap px-4 pb-0">
                                        <div className='bxTitle'>
                                            <span>Ico Referral income</span>
                                        </div>
                                    </div>
                                    <div className="px-4 mb-3">
                                        <div className='row justify-content-between'>
                                            <div className="col-md-6 mb-2 mb-md-0 text-center text-md-left">
                                                <div className='d-inline-flex g-8 align-items-center'>
                                                    <span className='fs-18 fw-400 text-white-60'>Show</span>
                                                    <div className='form-group mb-0 formInputs gradientBg'>
                                                        <select className='form-control' onChange={(e) => {
                                                            setRowsPerPage(Number(e.target.value));
                                                            setPage(0);
                                                        }}>
                                                            <option value="10">10</option>
                                                            <option value="30">30</option>
                                                            <option value="50">50</option>
                                                        </select>
                                                    </div>
                                                    <span className='fs-18 fw-400 text-white-60'>entries</span>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className='table-responsive mb-3'>
                                        <table className='table myapptable table-hover table-borderless mb-0'>
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>

                                                    <th className='pl-4'>user Id</th>
                                                    <th>User Name</th>
                                                    <th>Level</th>
                                                    <th>Referral Income</th>
                                                    <th>Wallet</th>
                                                    <th>Date & Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    userHistory?.data && userHistory.data.length > 0 ? (
                                                        userHistory.data.map((v, i) => (
                                                            <tr key={v?._id}>
                                                                <td className='pl-4'>{page * rowsPerPage + (i + 1)}</td>

                                                                <td className='pl-4 text-nowrap'>
                                                                    {v?.memberIdby}
                                                                    {(uniqueId === v?._id) ? (
                                                                        <Check size={20} color={"#FCD535"} cursor={'not-allowed'} />
                                                                    ) : (
                                                                        <button
                                                                            type="button"
                                                                            aria-label="Copy ID"
                                                                            onClick={() => copyuserAddress(v)}
                                                                            onKeyDown={(e) => e.key === 'Enter' && copyuserAddress(v)}
                                                                            style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                                                                        >
                                                                            <img src={require('../../../assets/images/master-wallet/copyIcon.svg').default} alt='copyIcon' />
                                                                        </button>
                                                                    )}
                                                                </td>
                                                                <td>{v?.usernameby ? v?.usernameby : "--"}</td>
                                                                <td className='text-nowrap'>Level {v?.level}</td>
                                                                <td>{(v?.amount)?.toString().includes('.') ? parseFloat(v?.amount)?.toFixed(5).replace(/(\.0+)?$/, '') : v?.amount} <span className="text-white-60">USDT</span></td>
                                                                <td>{v?.walletName}</td>
                                                                <td className='pr-4 text-nowrap'>
                                                                    <span>{moment(v.createdAt).format("DD/MM/YYYY | hh:mm A")}</span>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="7" className="text-center">No data found</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="px-4">
                                        <div className='row'>

                                            <div className='col-lg-12'>
                                                <Pagination aria-label="Page navigation" className='customPagination'>

                                                    <PaginationItem disabled={page === 0}>
                                                        <PaginationLink previous href="#" onClick={() => handlePageChange(page - 1)} className='prevbtn'>
                                                            <i className='bi bi-arrow-left align-bottom'></i> Previous
                                                        </PaginationLink>
                                                    </PaginationItem>
                                                    <span className='number'>
                                                        {Array.from({ length: totalPages }, (_, index) => (
                                                            <PaginationItem key={index} active={index === page}>
                                                                <PaginationLink href="#" onClick={() => handlePageChange(index)}>
                                                                    {index + 1}
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                        ))}

                                                    </span>

                                                    <PaginationItem disabled={page === totalPages - 1}>
                                                        <PaginationLink next href="#" onClick={() => handlePageChange(page + 1)} className='nextbtn'>
                                                            Next <i className='bi bi-arrow-right align-bottom'></i>
                                                        </PaginationLink>
                                                    </PaginationItem>
                                                </Pagination>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
}
MasterICO.propTypes = {
    userHistory: PropTypes.shape({
        data: PropTypes.arrayOf(
            PropTypes.shape({
                data: PropTypes.array.isRequired,
                pagination: PropTypes.shape({
                    total: PropTypes.number.isRequired
                }).isRequired
            }).isRequired
        ).isRequired
    }).isRequired,
    setRowsPerPage: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};
export default MasterICO;